//react
import { Component } from 'react';
import ReactGA from 'react-ga';

ReactGA.initialize('');

class Tracking extends Component {
	render() {
		ReactGA.pageview(window.location.pathname + window.location.search);

		return this.props.children;
	}
}

export default Tracking;



// WEBPACK FOOTER //
// ./src/components/tracking/tracking.js